export const getStage = state => state.welcome.stage;
export const isActive = state => getStage(state) !== null;
export const isWelcoming = state => state.welcome.stage !== null;
